import get from 'lodash/get';
import keyBy from 'lodash/keyBy';
import { createReducer } from '@reduxjs/toolkit';

import { ActionSuccessType, GET_DOWNLOAD_APP_MESSAGES, GET_SESSIONS_CONTENTS } from 'constants/redux-actions';

const initState = {};

const contentsSystemReducer = createReducer(initState, {
  [ActionSuccessType(GET_DOWNLOAD_APP_MESSAGES)]: (prevState, action) => {
    const contents = get(action, 'payload.data', []);

    return { ...prevState, ...keyBy(contents, 'key') };
  },

  [ActionSuccessType(GET_SESSIONS_CONTENTS)]: (prevState, action) => {
    const contents = get(action, 'payload.data', []);

    return { ...prevState, ...keyBy(contents, 'key') };
  },
});

export default contentsSystemReducer;
